import { Box, Paper, Typography } from "@mui/material";
import { useRecords } from "../../../../api/useRecords";
import { NFBsessionGradeValues } from "../../types";
import { useSessionGrade } from "../../utils";

type NFBData = {
    id: number;
    minutes_of_trainning: number;
    neurofeedback_session_grade: Array<NFBsessionGradeValues>;
};

type NeurofeedbackScoresPresentationProps = {
    treatmentId: string;
    cardWidth: string
};

export const NeurofeedbackScoresPresentation = ({ treatmentId, cardWidth }: NeurofeedbackScoresPresentationProps) => {
    const { data } = useRecords("neurofeedback_data", "*.*", {
        extraOptions: {
            filter: {
                protocol: { treatment: { id: { _eq: treatmentId } } },
            },
        },
    });
    const nfbData: Array<NFBData> = data?.items ?? [];
    const numberNFBSessions = nfbData.length;

    const nfbSessionGrades: Array<NFBsessionGradeValues> = nfbData.flatMap(
        (nfb) => nfb.neurofeedback_session_grade
    );
    const sessionGrades = useSessionGrade(nfbSessionGrades);

    if (!nfbData || numberNFBSessions < 1 || !sessionGrades) return null;

    const totalDuration = nfbData.reduce((sum, curr) => {
        return sum + (curr?.minutes_of_trainning ?? 0);
    }, 0);

    const totalCollaboration = nfbData.reduce((sum, curr) => {
        const grade = curr.neurofeedback_session_grade?.[0];
        return sum + (grade?.client_collaboration ?? 0);
    }, 0);

    const totalSessionGrades = sessionGrades.reduce((sum, curr) => {
        return sum + (curr?.sessionGlobalGrade ?? 0);
    }, 0);

    const clientColaborationAverage = (totalCollaboration / numberNFBSessions).toFixed(1);
    const sessionGlobalGradesAverage = (totalSessionGrades / numberNFBSessions).toFixed(1);
    const expectedMinutes = 20 + (numberNFBSessions - 1) * 35;

    const stats = [
        { label: "Total minutos:", value: `${totalDuration.toFixed(1)} / ${expectedMinutes}` },
        { label: "Média colab. cliente:", value: clientColaborationAverage },
        { label: "Média análise sessão:", value: sessionGlobalGradesAverage },
    ];

    return (
        <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
            {stats.map((stat) => (
                <Paper
                    key={stat.label}
                    elevation={0}
                    sx={{
                        padding: 2,
                        borderRadius: 2,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: 1,
                    }}
                >
                    <Typography variant="body1" color="primary" textAlign="left" noWrap>
                        {stat.label}
                    </Typography>
                    <Typography variant="body1">{stat.value}</Typography>
                </Paper>
            ))}
        </Box>
    );
};
